export default {
  date: /^[0-9]{2}\/[0-9]{2}\/[0-9]{4}$/,
  email:
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i,
  mobile: /^([0-9 ]{7,11})$/i,
  name: /^[a-z,.'\-\s]+$/i,
  number: /^\d+(,\d{3})*(\.\d{1,2})?$/i,
  phone: /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-s./0-9]*$/i,
};
